import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class JeevesCustomerConfigService {
  useInvoiceCreditBlocked = false;
  useCheckoutCreditCheck = false;
}
